<template>
	<div class="form-container">
		<h2 class="form-title">가입 시 입력한 정보</h2>

		<form @submit.prevent="onSubmitForm">
			<div class="form-group" :class="{ 'has-error': validMessage.userName }">
				<label class="form-label">이름</label>
				<input
					v-model="userName"
					class="form-input"
					type="text"
					:readonly="isSendCertSms"
				/>
				<FormInputHint :message="validMessage.userName"></FormInputHint>
			</div>

			<div class="form-group">
				<label class="form-label">휴대전화 번호</label>

				<div :class="{ 'has-error': validMessage.userHp }">
					<div class="columns">
						<div class="column col-7">
							<input
								v-model="userHp"
								class="form-input"
								type="text"
								placeholder="- 없이 숫자만 입력"
								:readonly="isCertSuccess"
							/>
						</div>
						<div class="column col-5">
							<BaseBtn
								v-if="!isSendCertSms"
								@click="onClickSendCertSms"
								type="button"
								color="primary"
								medium
								block
								:disabled="validMessage.userHp !== ''"
							>
								인증번호 받기
							</BaseBtn>
							<BaseBtn
								v-else
								@click="onClickSendCertSms"
								type="button"
								color="secondary"
								medium
								block
								:disabled="validMessage.userHp !== '' || isCertSuccess"
							>
								인증번호 재발송
							</BaseBtn>
						</div>
					</div>

					<FormInputHint :message="validMessage.userHp"></FormInputHint>
				</div>

				<!-- 인증번호 전송 성공 후 노출 -->
				<div v-if="isSendCertSms">
					<div class="columns">
						<div class="column col-12">
							<input
								v-model="certNumber"
								class="form-input"
								type="text"
								placeholder="인증번호 입력"
								:class="{
									'is-success': isCertSuccess,
									'is-error': !isCertSuccess && validCertNumber,
								}"
								:readonly="isCertSuccess"
							/>

							<FormInputHint :message="validCertNumber"></FormInputHint>
						</div>
						<div v-if="!isCertSuccess" class="column col-12">
							<BaseBtn
								@click="onClickCheckCertNumber"
								type="button"
								color="primary"
								medium
								block
								:disabled="!certNumber"
								>확인
							</BaseBtn>
						</div>
					</div>
				</div>
			</div>

			<div class="form-group form-button">
				<BaseBtn type="submit" color="primary" x-large block
					>아이디 찾기</BaseBtn
				>
			</div>
		</form>
	</div>
</template>

<script>
import mixin from '@/mixins/mixin';

import BaseBtn from '@/components/common/Btn';
import FormInputHint from '@/components/common/FormInputHint';

import validation from '@/utils/validation';
import { sendCertSms, checkCertNumber } from '@/api';

export default {
	mixins: [mixin],
	components: {
		BaseBtn,
		FormInputHint,
	},
	data() {
		return {
			userName: '',
			userHp: '',
			certNumber: '',

			// 인증번호 발송 여부
			isSendCertSms: false,

			// 인증 완료 여부
			isCertSuccess: false,

			certId: null,

			// 유효성 검사
			validMessage: {},
			validCertNumber: '',
		};
	},
	watch: {
		userName(val) {
			this.validMessage.userName = validation.getValidUserName(val);
		},
		userHp(val) {
			this.validMessage.userHp = validation.getValidUserHp(val);
		},
	},
	methods: {
		onClickSendCertSms() {
			this.sendCertSmsToUserHp();
		},
		async sendCertSmsToUserHp() {
			const params = {
				userName: this.userName,
				userHp: this.userHp,
			};

			const { data } = await sendCertSms(params);

			if (data.code === '00000') {
				this.isSendCertSms = true;
			} else {
				const message = data.message;
				const options = {
					message,
				};
				this.showAlert(options);
			}
		},
		async onClickCheckCertNumber() {
			const params = {
				userName: this.userName,
				userHp: this.userHp,
				certNumber: this.certNumber,
			};

			const { data } = await checkCertNumber(params);

			this.validCertNumber = data.message;

			// 인증 완료
			if (data.code === '00000') {
				this.isCertSuccess = true;
				this.certId = data.certId;
			}
		},
		async onSubmitForm() {
			// 입력값 검증
			if (!this.userName) {
				const options = {
					message: '가입 시 등록한 이름을 입력해 주세요.',
				};
				this.showAlert(options);
				return false;
			}

			if (!this.userHp) {
				const options = {
					message: '가입 시 등록한 휴대 전화번호를 입력해 주세요.',
				};
				this.showAlert(options);
				return false;
			}

			// 인증 완료 여부 확인
			if (!this.isCertSuccess) {
				const options = {
					message: '휴대 전화번호 본인 인증 후 진행해 주세요.',
				};
				this.showAlert(options);
				return false;
			}

			const payload = {
				userName: this.userName,
				userHp: this.userHp,
				certId: this.certId,
			};

			const { data } = await this.$store.dispatch(
				'findIdStore/getUserInfo',
				payload,
			);

			if (data.code === '00000') {
				this.$emit('nextPage');
			} else {
				const options = {
					message: data.message || '아이디를 찾을 수 없습니다.',
				};
				this.showAlert(options);
			}
		},
	},
};
</script>
